import { sectionNames } from "@saleor/intl";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, Routes, useLocation, useParams } from "react-router-dom";

import { WindowTitle } from "../components/WindowTitle";
import SellerCreate from "./views/SellerCreate";
import SellerDetailsComponent from "./views/SellerDetails";
import SellerListComponent from "./views/SellerList";

const SellerList: React.FC = () => {
  const location = useLocation();
  const params = parseQs(location.search.substr(1));
  return <SellerListComponent params={params} />;
};

const SellerDetails: React.FC = () => {
  const { id } = useParams();
  const params = parseQs(location.search.substr(1));
  return <SellerDetailsComponent id={decodeURIComponent(id)} params={params} />;
};

const Component = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.seller)} />
      <Routes>
        <Route path={""} element={<SellerList />} />
        <Route path={"add"} element={<SellerCreate />} />
        <Route path={":id"} element={<SellerDetails />} />
      </Routes>
    </>
  );
};

export default Component;
